import type { ResellerPermission } from "@xop-any-time/shared";
import type { JSX, ReactNode } from "react";

import { NoAccessPanel } from "../components/ui/no-access-panel.js";
import { usePermissions } from "./usePermissions.js";

/** Route-level courtesy (spec F §6.3): the panel instead of the page. Not a
 * gate — the page's own requests would be refused by crm-api regardless. */
export function RequirePermission({
  permission,
  children,
}: {
  permission: ResellerPermission;
  children: ReactNode;
}): JSX.Element {
  const { can } = usePermissions();
  return can(permission) ? <>{children}</> : <NoAccessPanel permission={permission} />;
}
